import { createAction } from '@reduxjs/toolkit'
import reducer from './reducer'

export const {
  fetchOffersSuccess,
  fetchOffersFailure,
  setLoading,
  saveFilters,
  setActiveTab,
  setSelectedRowKeys,
  setBulkActionLoading,
  setNetworks,
  setGameGenres,
  setProgramDetail,
  setProgramLoading,
  setProgramSaving,
  setGoalDetail,
  setGoalLoading,
  setGoalSaving,
  setFeatureSaving,
  clearData,
} = reducer.actions

export const fetchOffers = createAction('earnOffersManagement/fetchOffers')
export const fetchNetworks = createAction('earnOffersManagement/fetchNetworks')
export const fetchGameGenres = createAction('earnOffersManagement/fetchGameGenres')
export const bulkApprove = createAction('earnOffersManagement/bulkApprove')
export const bulkDecline = createAction('earnOffersManagement/bulkDecline')
export const bulkUndo = createAction('earnOffersManagement/bulkUndo')
export const fetchNetworkProgram = createAction('earnOffersManagement/fetchNetworkProgram')
export const createNetworkProgram = createAction('earnOffersManagement/createNetworkProgram')
export const updateNetworkProgram = createAction('earnOffersManagement/updateNetworkProgram')
export const deleteNetworkProgram = createAction('earnOffersManagement/deleteNetworkProgram')
export const fetchNetworkProgramGoal = createAction('earnOffersManagement/fetchNetworkProgramGoal')
export const createNetworkProgramGoal = createAction('earnOffersManagement/createNetworkProgramGoal')
export const updateNetworkProgramGoal = createAction('earnOffersManagement/updateNetworkProgramGoal')
export const deleteNetworkProgramGoal = createAction('earnOffersManagement/deleteNetworkProgramGoal')
export const createNetworkProgramFeature = createAction('earnOffersManagement/createNetworkProgramFeature')
export const deleteNetworkProgramFeature = createAction('earnOffersManagement/deleteNetworkProgramFeature')
